(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mewant-bmw-detail-a"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mewant-bmw-detail')) {
  customElements.define('mewant-bmw-detail', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this._carousels = [];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-carousel]').forEach(root => {
        const track = root.querySelector('[data-track]');
        const slides = Array.from(track.querySelectorAll('[data-slide]'));
        const dots = Array.from(root.querySelectorAll('[data-dot]'));
        const controls = root.querySelector('[data-controls]');
        if (slides.length < 2) return;
        controls.hidden = false;
        const pause = root.querySelector('[data-pause]');
        const counter = root.querySelector('[data-counter]');
        const state = { root, track, slides, index: 0, timer: null, paused: false, hover: false, focus: false, visible: false, frame: null };
        this._carousels.push(state);
        const canAuto = () => this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' && !reduced.matches;
        const stop = () => { clearTimeout(state.timer); state.timer = null; };
        const schedule = () => {
          stop();
          if (!canAuto() || state.paused || state.hover || state.focus || !state.visible || document.hidden) return;
          state.timer = setTimeout(() => { if (canAuto()) go(state.index + 1, false); }, Math.max(4000, Number(this.dataset.interval) || 6000));
        };
        const update = () => {
          state.frame = null;
          const box = track.getBoundingClientRect();
          let closest = 0, distance = Infinity;
          slides.forEach((slide, i) => {
            const d = Math.abs(slide.getBoundingClientRect().left - box.left);
            if (d < distance) { distance = d; closest = i; }
          });
          state.index = closest;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === closest)));
          counter.textContent = `${closest + 1} / ${slides.length}`;
          schedule();
        };
        const go = (index, user = true) => {
          const target = ((index % slides.length) + slides.length) % slides.length;
          if (user) { state.paused = true; syncPause(); }
          const offset = slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: offset, behavior: reduced.matches || this.dataset.editor === 'true' ? 'auto' : 'smooth' });
          state.index = target;
          stop();
        };
        const syncPause = () => {
          pause.hidden = !canAuto();
          pause.setAttribute('aria-pressed', String(state.paused));
          pause.setAttribute('aria-label', state.paused ? root.dataset.playLabel : root.dataset.pauseLabel);
          pause.querySelector('[data-pause-icon]').textContent = state.paused ? '▶' : 'Ⅱ';
          counter.setAttribute('aria-live', canAuto() && !state.paused ? 'off' : 'polite');
        };
        root.querySelector('[data-prev]').addEventListener('click', () => go(state.index - 1), { signal });
        root.querySelector('[data-next]').addEventListener('click', () => go(state.index + 1), { signal });
        dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
        track.addEventListener('scroll', () => { if (!state.frame) state.frame = requestAnimationFrame(update); }, { passive: true, signal });
        track.addEventListener('pointerdown', () => { state.paused = true; syncPause(); stop(); }, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(state.index + (event.key === 'ArrowRight' ? 1 : -1)); }
          if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); go(event.key === 'Home' ? 0 : slides.length - 1); }
        }, { signal });
        root.addEventListener('mouseenter', () => { state.hover = true; stop(); }, { signal });
        root.addEventListener('mouseleave', () => { state.hover = false; schedule(); }, { signal });
        root.addEventListener('focusin', () => { state.focus = true; stop(); }, { signal });
        root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { state.focus = false; schedule(); } }, { signal });
        pause.addEventListener('click', () => { state.paused = !state.paused; syncPause(); schedule(); }, { signal });
        document.addEventListener('visibilitychange', schedule, { signal });
        reduced.addEventListener('change', () => { syncPause(); schedule(); }, { signal });
        const observer = new IntersectionObserver(entries => { state.visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.25 });
        observer.observe(root); state.observer = observer;
        const resize = new ResizeObserver(() => { go(state.index, false); update(); });
        resize.observe(track); state.resize = resize;
        document.addEventListener('shopify:block:select', event => {
          const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { go(index, false); update(); }
        }, { signal });
        syncPause(); update();
      });
    }
    disconnectedCallback() {
      this._controller?.abort(); this._controller = null;
      (this._carousels || []).forEach(state => { clearTimeout(state.timer); cancelAnimationFrame(state.frame); state.observer.disconnect(); state.resize.disconnect(); });
      this._carousels = [];
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mewant-collection-seo-top-de"]) return;
  try {
    
  (() => {
    const mount = () => {
      document.querySelectorAll('[data-mewant-h1-slot]').forEach((slot) => {
        const title = document.querySelector('.collection__title');
        if (!title || slot.contains(title)) return;
        title.textContent = slot.dataset.mewantH1;
        slot.append(title);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mewant-mercedes-collection-seo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountMercedesHeading = () => {
      const slot = document.querySelector('[data-mewant-mercedes-h1-slot]');
      const title = document.querySelector('.collection__title');
      if (!slot || !title || slot.contains(title)) return;
      title.textContent = slot.dataset.mewantMercedesH1;
      slot.append(title);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountMercedesHeading);
    } else {
      mountMercedesHeading();
    }

    document.addEventListener('shopify:section:load', mountMercedesHeading);
  })();

  } catch(e) { console.error(e); }
})();
})();
